import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumJourneyLabelStatus implements BaseEnumType {
  private static allValues: EnumJourneyLabelStatus[] = []; // make sure this is top-most
  
  public static unused = new EnumJourneyLabelStatus(0, "Unused", "enum_journey_label_status_unused");
  public static racked = new EnumJourneyLabelStatus(1, "Racked", "enum_journey_label_status_racked");
  public static delivered = new EnumJourneyLabelStatus(2, "Delivered", "enum_journey_label_status_delivered");
  public static returned = new EnumJourneyLabelStatus(3, "Returned", "enum_journey_label_status_returned");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumJourneyLabelStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnused() { return this === EnumJourneyLabelStatus.unused; }
  public isRacked() { return this === EnumJourneyLabelStatus.racked; }
  public isDelivered() { return this === EnumJourneyLabelStatus.delivered; }
  public isReturned() { return this === EnumJourneyLabelStatus.returned; }

  public static getValues(): readonly EnumJourneyLabelStatus[] {
    return EnumJourneyLabelStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumJourneyLabelStatus[] {
    return EnumJourneyLabelStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumJourneyLabelStatus {
    const found = EnumJourneyLabelStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumJourneyLabelStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumJourneyLabelStatus): EnumJourneyLabelStatus {
    const found = name ? EnumJourneyLabelStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumJourneyLabelStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumJourneyLabelStatus>): boolean {
    return this.key === other?.key;
  }
}